import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HttpContextToken,
  HttpResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ErrorHandlerService } from '../services/error-handler.service';

/** Set this context token to true to suppress the global error dialog */
export const SKIP_ERROR_HANDLER = new HttpContextToken<boolean>(() => false);

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(private readonly errorHandler: ErrorHandlerService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      tap(event => {
        // Cuando llega una respuesta exitosa el backend está vivo → reset del cache de dedup
        // para que un próximo error sí pueda notificar al usuario.
        if (event instanceof HttpResponse) {
          this.errorHandler.notifyResponseOk();
        }
      }),
      catchError((error: HttpErrorResponse) => {
        const skipHandler = request.context.get(SKIP_ERROR_HANDLER);
        // 401 errors are handled by AuthInterceptor (token refresh)
        if (error.status !== 401 && !skipHandler) {
          this.errorHandler.handleError(error);
        }
        return throwError(() => error);
      })
    );
  }
}
